import { Directive, ElementRef, AfterContentChecked, Input } from '@angular/core';

@Directive({
  selector: '[inputAutowidth]'
})
export class InputAutowidthDirective implements AfterContentChecked {
  emptyWidth: number;

  @Input() set inputAutowidth(inputAutowidth: number) {
    this.emptyWidth = inputAutowidth;
    this.resize();
  }

  constructor(private element: ElementRef) {
    this.resize();
  }

  ngAfterContentChecked() {
    this.resize();
  }

  resize() {
    if(!this.element)
      return;
    this.element.nativeElement.style.width = 0;
    this.element.nativeElement.style.width = (this.element.nativeElement.value?.length > 0 ? this.element.nativeElement.scrollWidth + 1 : this.emptyWidth || 0) + 'px'; 
  }
}